import React from 'react';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import InputWrapper from './InputWrapper';

const PrimeCalendar = ({ value, onChange, placeholder, label, error, name }) => {
  addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      today: 'Hoy',
      clear: 'Limpiar',
      dateFormat: 'yy/mm/dd',
  });

  return (
    <InputWrapper label={label} error={error}>
      <Calendar className="w-100 date-picker" value={value} onChange={onChange} placeholder={placeholder} showIcon name={name} appendTo="self" locale="es" />
    </InputWrapper>
  );
};

export default PrimeCalendar;